import './styles/main.scss';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {useEffect, useMemo, useState} from "react";
import InstallPage from "./pages/InstallPage";
import MainPage from "./pages/MainPage";
import RefreshResumePage from "./pages/RefreshResumePage";
import ChatPage from "./pages/ChatPage";
import Loading from "./elements/Loading";
import HhAuthorizePage from "./pages/HhAuthorizePage";
import HhChatAuthorizePage from "./pages/HhChatAuthorizePage";
import VacancySettingsPage from "./pages/VacancySettingsPage";
import ApplicantAnalysPage from "./pages/ApplicantAnalysPage";
import ResumeSelectionPage from "./pages/ResumeSelectionPage";
import ResumeDashboardPage from "./pages/ResumeDashboardPage";
import getAPIClient from "./hooks/apiClient";

function App() {
    const [appInitialized, setAppInitialized] = useState(false)
    const [appLoaded, setAppLoaded] = useState(false)

    const BX24 = useMemo(() => {
        if (
            window.location.pathname.includes('hh_authorize') ||
            window.location.pathname.includes('hh_chat_authorize')
        ){
            setAppInitialized(true)
            return
        }
        const bx = window.BX24
        bx.init(() => setAppInitialized(true));
        return bx;
    }, [])

    useEffect(() => {
        if (!appInitialized) {
            return
        }
        if (
            window.location.pathname.includes('hh_authorize') ||
            window.location.pathname.includes('hh_chat_authorize') ||
            window.location.pathname.includes('install')
        ){
            setAppLoaded(true)
            return
        }
        const api = getAPIClient(BX24)
        api.get('/bitrix_portals/settings').then(() => {setAppLoaded(true)})
    }, [appInitialized])

    if (!appLoaded) {
        return <Loading isLoading={true}/>
    }
    return (
        <BrowserRouter>
            <Routes>
                <Route exact path="/" element={<MainPage BX24={BX24}/>} />
                <Route exact path="/hh_authorize" element={<HhAuthorizePage/>} />
                <Route exact path="/install" element={<InstallPage BX24={BX24}/>} />
                <Route exact path="/update_crm_item" element={<RefreshResumePage BX24={BX24}/>} />
                <Route exact path="/vacancy_settings" element={<VacancySettingsPage BX24={BX24}/>} />
                <Route exact path="/applicant_analys" element={<ApplicantAnalysPage BX24={BX24}/> } />
                <Route exact path="/resume_selection" element={<ResumeSelectionPage BX24={BX24}/> } />
                <Route exact path="/resume_dashboard" element={<ResumeDashboardPage BX24={BX24}/> } />
                <Route exact path="/chat" element={<ChatPage BX24={BX24}/>} />
                <Route exact path="/hh_chat_authorize" element={<HhChatAuthorizePage/>} />
            </Routes>
        </BrowserRouter>
    )
}

export default App;
